var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 251,
    viewBox: "0 0 312 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3856_3543)",
    filter: "url(#filter0_d_3856_3543)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M265.705 88.5752H34V212.22H265.705V88.5752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278 30H42.2256V201.96H278V30Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278 30H42.2256V48.7026H278V30Z",
    fill: "url(#paint0_linear_3856_3543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0626 34.5024H50.1484V44.2434H60.0626V34.5024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1335 132.518H84.6523V164.771H94.1335V132.518Z",
    fill: "#C4E1E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.187 104.94H102.706V164.815H112.187V104.94Z",
    fill: "#C4E1E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.197 84.376H120.716V164.771H130.197V84.376Z",
    fill: "#C4E1E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.207 93.251H138.726V164.771H148.207V93.251Z",
    fill: "#C4E1E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.217 68.7036H156.735V164.814H166.217V68.7036Z",
    fill: "#C4E1E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1335 146.978H84.6523V164.771H94.1335V146.978Z",
    fill: "url(#paint1_linear_3856_3543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.7 181.538V174.871L76.1303 174.871V181.538L176.7 181.538Z",
    fill: "#9DD0DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.799 68.7036H189.076V73.8555H243.799V68.7036Z",
    fill: "#C4E1E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.799 79.7871H189.076V84.939H243.799V79.7871Z",
    fill: "#C4E1E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.799 90.9131H189.076V96.065H243.799V90.9131Z",
    fill: "#C4E1E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.187 124.162H102.706V164.771H112.187V124.162Z",
    fill: "url(#paint2_linear_3856_3543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.197 102.646H120.716V164.771H130.197V102.646Z",
    fill: "url(#paint3_linear_3856_3543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.207 124.682H138.726V164.771H148.207V124.682Z",
    fill: "url(#paint4_linear_3856_3543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.217 86.8867H156.735V164.814H166.217V86.8867Z",
    fill: "url(#paint5_linear_3856_3543)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3856_3543",
    x: 0,
    y: 0,
    width: 312,
    height: 250.221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3856_3543"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3856_3543",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3856_3543",
    x1: 42.2324,
    y1: 39.3568,
    x2: 277.993,
    y2: 39.3568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#00616E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3856_3543",
    x1: 89.4119,
    y1: 103.633,
    x2: 89.4119,
    y2: 171.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9C961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9AA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3856_3543",
    x1: 107.429,
    y1: 103.633,
    x2: 107.429,
    y2: 171.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9C961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9AA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3856_3543",
    x1: 125.446,
    y1: 103.633,
    x2: 125.446,
    y2: 171.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9C961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9AA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3856_3543",
    x1: 138.011,
    y1: 81.1339,
    x2: 145.421,
    y2: 167.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#00616E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3856_3543",
    x1: 157.506,
    y1: 79.4628,
    x2: 164.916,
    y2: 165.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#00616E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3856_3543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 244,
    height: 182.221,
    fill: "white",
    transform: "translate(34 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/Graph.a32cf815076bc8a5b009f5481d308957.svg";
export { ForwardRef as ReactComponent };